import { FlexCol } from "src/utils/flexLayouts";
import { FC, useContext, useEffect, useState } from "react";
import { TestRegistryContext } from "../store/testRegistryContext";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import { getItems } from "src/modules/spItems/actions";
import { questionsRegistry } from "src/api/config/notifications.config";
import { selectItems } from "src/modules/spItems/selectors";
import { MinCorrectAnswersCount } from "./MinCorrectAnswersCount";
import { EditTestFooter } from "./RegistryTestFooter";
import { QuestionsList } from "./QuestionsList";
import { BtnAddQuestion } from "./formRegistryTest/BtnAddQuestion";
import { EditingQuestion } from "./EditingQuestion";
import { setOpenForm } from "../store/testRegistryActions";
import { TestName } from "./TestName";
import { DropResult } from "react-beautiful-dnd";

interface IProps {
  shouldUpdateTestList: () => void;
}

export const EditTest: FC<IProps> = ({ shouldUpdateTestList }) => {
  const { state, dispatchTestRegistry } = useContext(TestRegistryContext);
  const [question, setQuestion] = useState({});
  const [questions, setQuestions] = useState<any>([]);

  const dispatch = useAppDispatch();

  const questionsList = useAppSelector(state => selectItems(state, questionsRegistry));

  useEffect(() => {
    dispatch(
      getItems({
        listName: questionsRegistry,
        filters: { ID: state.test.QuestionsID }
      })
    );
  }, [state.test, state.minCorrectAnswersCount, state.test.QuestionsID]);

  useEffect(() => {
    setQuestions(
      questionsList.sort((a, b) => {
        return state.test.QuestionsID.indexOf(a.ID) - state.test.QuestionsID.indexOf(b.ID);
      })
    );
  }, [questionsList]);

  const onDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const reorderedQuestions = Array.from(questions);
    const [movedQuestion] = reorderedQuestions.splice(result.source.index, 1);
    reorderedQuestions.splice(result.destination.index, 0, movedQuestion);
    setQuestions(reorderedQuestions);
  };

  const editQuestion = (id: number) => {
    setQuestion(questionsList.find(question => question.ID === id));
    dispatchTestRegistry(setOpenForm(true));
  };

  return (
    <FlexCol className="py-5 px-7.5 gap-5 flex">
      <div className="bg-white shadow-custom py-5 px-[25px] rounded-md gap-[10px] font-medium">
        {!state.openForm ? (
          <div>
            <TestName />
            <QuestionsList questions={questions} editQuestion={editQuestion} onDragEnd={onDragEnd} />
            <MinCorrectAnswersCount />
            <BtnAddQuestion />
            <EditTestFooter questions={questions} shouldUpdateTestList={shouldUpdateTestList} />
          </div>
        ) : (
          <EditingQuestion question={question} />
        )}
      </div>
    </FlexCol>
  );
};
